











import { Vue, Component, Prop } from "vue-property-decorator"
import { ICampaign } from "../../../api_interface"
import { i18nTranslate } from "../../../../i18n"

@Component
export default class extends Vue {
  @Prop({ required: true })
  campaignDone!: boolean

  @Prop({ required: true })
  newMedal!: ICampaign["medals"][0]

  @Prop({ required: true })
  campaign!: ICampaign

  get line1() {
    const lines = this.medalName.split("\n")
    return lines.length < 2 ? this.$t("congratulations") : lines[0]
  }

  get line2() {
    const lines = this.medalName.split("\n")
    return lines.length < 2 ? lines[0] : lines.slice(1).join("\n")
  }

  get medalName() {
    return i18nTranslate(this.newMedal.name!)
  }

  get campaignDoneMessage() {
    if (this.campaign.done_message) {
      return i18nTranslate(this.campaign.done_message)
    } else {
      return i18nTranslate({
        ja: "キャンペーンの目標を達成しました！",
        en: "You achieved the goal of the campaign!",
      })
    }
  }
}
